import { Link } from "react-router-dom"
import "./styleModal.css"
import { Modal } from "react-bootstrap";
import { useState } from "react";

interface ChildsProps {
    mensaje: string;
    redireccionar?: boolean; 
}

const ModalSuccessChanges: React.FC<ChildsProps> = ({ mensaje, redireccionar }) => {
    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Body>
                    <div >
                        <Link className="close" to="#"></Link>
                        <div className="d-flex flex-column">
                            <div className="contenedor-mensaje-modalSuccesChanges">
                                <h3 className="text-center">{mensaje}</h3>
                                <h1 className="text-center">
                                    <div className="checkmark-circle">
                                        <div className="background"></div>
                                        <div className="checkmark draw"></div>
                                    </div>
                                </h1>
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                            {redireccionar?
                            <button className="btn btn-primary btn-lg" onClick={() => handleClose()}>
                                  Aceptar  
                            </button>
                            :
                                <Link to="/home" >
                                    <button className="btn btn-primary btn-lg" >
                                        Volver al Inicio
                                    </button>
                                </Link>
                            }

                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}




export default ModalSuccessChanges